import Axios from "../utils/tms-axios/tms-axios";

const TmsCounterScanPermissionService = {
  getPermissions: async (counterId, page = 1, limit = 200) => {
    const resp = await Axios.get(
      `v1/counter-scan-permissions?counterId=${counterId}&page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  createPermission: async (counterId, productType, productIds = []) => {
    const resp = await Axios.post(
      "v1/counter-scan-permissions",
      { counterId: Number(counterId), productType, productIds },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  updatePermission: async (id, productIds) => {
    const resp = await Axios.put(
      `v1/counter-scan-permissions/${id}`,
      { productIds },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  deletePermission: async (id) => {
    const resp = await Axios.delete(`v1/counter-scan-permissions/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
};

export default TmsCounterScanPermissionService;
